import React from "react";
import TextInput from "../../../shared/components/forms/TextInput";
import Textarea from "../../../shared/components/forms/Textarea";
import NumberInput from "../../../shared/components/forms/NumberInput";
import Select from "../../../shared/components/forms/Select";
import SelectOptions from "../../../../utils/SelectOptions";

function BusinessTrustpassInformationForm({
  information,
  errors,
  disabled,
  onChangeValue,
  dataPoints,
  onSave,
  onFocus
}) {

  const invalidUid = ["lessthan11", "morethan21", "BBBBBB1041", "BBBB100191", "BBBBBB5091"];
  function dataPointSelectOption(type) {
    const dataPoint = dataPoints[type];
    if (!dataPoint) return [];

    return dataPoint.data_point_options.map((option) => {
      if (invalidUid.includes(option.uid)) return null;
      return { text: option.text, value: option.text };
    }).filter((item) => { return !!item; });
  }

  function dataPointSelectOptionSubIndustry(industryName) {
    const dataPoint = dataPoints['AAindustr1'];
    if (!dataPoint) return [];

    const industry = dataPoint.data_point_options.find((option) => {
      return option.text === industryName;
    });
    if (!industry) return [];

    return industry.children.map((option) => {
      return { text: option.text, value: option.text };
    });
  }

  return (
    <section className="cardSection">
      <TextInput
        label="Company Name"
        name="company_name"
        placeholder="Enter Company Name"
        value={information.company_name || ""}
        error={errors.company_name}
        disabled={disabled}
        onChange={onChangeValue("company_name")}
        tip="Must match company name on all business documents"
      />

      <div className="ds-formGroup">
        <Select
          label="Company Type"
          name="company_type"
          placeholder="Select Company Type"
          options={SelectOptions.business_type}
          value={information.company_type || ""}
          error={errors.company_type}
          disabled={disabled}
          onChange={onChangeValue("company_type")}
          onFocus={onFocus}
        />

        <NumberInput
          label="Year of Registration"
          name="year_of_registration"
          placeholder="Enter Year of Registration"
          value={information.year_of_registration || ""}
          error={errors.year_of_registration}
          disabled={disabled}
          onChange={onChangeValue("year_of_registration")}
          tip="Found on {DTI or SEC} Certificate"
        />
      </div>
      <Select
        label="Number of Employees"
        name="number_of_employees"
        placeholder="Select Number of Employees"
        options={dataPointSelectOption('numberofe1')}
        value={information.number_of_employees || ""}
        onChange={onChangeValue("number_of_employees")}
        disabled={disabled}
        includeBlank="Select Number of Employees"
        onFocus={onFocus}
      />
      <div className="ds-formGroup">
        <Select
          label="Industry"
          name="industry"
          placeholder="Select Industry"
          options={dataPointSelectOption('AAindustr1')}
          value={information.industry}
          onChange={onChangeValue("industry")}
          disabled={disabled}
          includeBlank="Select Industry"
          onFocus={onFocus}
        />
        <Select
          label="Sub Industry"
          name="sub_industry"
          placeholder="Select Sub Industry"
          options={dataPointSelectOptionSubIndustry(information.industry)}
          value={information.sub_industry}
          onChange={onChangeValue("sub_industry")}
          disabled={disabled}
          includeBlank="Select Sub Industry"
          onFocus={onFocus}
        />
      </div>
      <div className="ds-formGroup">
        <NumberInput
          label="Company Contact Number"
          name="company_contact_number"
          placeholder="Enter Company Contact Number"
          value={information.company_contact_number || ""}
          error={errors.company_contact_number}
          disabled={disabled}
          onChange={onChangeValue("company_contact_number")}
          tip="Landline or Mobile Number"
        />
        <TextInput
          label="Company Website"
          tip="Optional"
          name="company_website"
          placeholder="Enter Company Website"
          value={information.company_website || ""}
          error={errors.company_website}
          disabled={disabled}
          onChange={onChangeValue("company_website")}
        />
      </div>

      <Textarea
        label="Company Address"
        name="company_address"
        placeholder="Enter Company Address"
        value={information.company_address || ""}
        error={errors.company_address}
        disabled={disabled}
        onChange={onChangeValue("company_address")}
        tip="Example: Unit 7, Jose Bldg, 5678 Maria St., Makati City, 1600"
      />
    </section>
  );
}


export default BusinessTrustpassInformationForm;



// WEBPACK FOOTER //
// ./src/features/trustpass/components/business/InformationForm.js